let portalRoot: HTMLElement | null = null;

/**
 * Shared, app-owned container for every React portal (bottom sheets, the
 * floating chicken, the tab-bar menu).
 *
 * We deliberately do NOT portal into `document.body`. Body's direct children
 * are also mutated by Next.js and the Telegram WebApp SDK; when they reorder or
 * remove a body child, React's later `body.removeChild(portalNode)` finds the
 * node's parent no longer matches its fiber and WebKit — strict where Blink and
 * Gecko are lenient — throws "NotFoundError: The object can not be found here."
 * mid-unmount, crashing on back-navigation to Home.
 *
 * A dedicated body-level node that only React writes into removes that
 * interference. It is created once and never torn down (app-lifetime), and is
 * appended last so portal children keep painting above the app shell.
 */
export function getPortalRoot(): HTMLElement {
  if (portalRoot && portalRoot.isConnected) return portalRoot;

  const existing = document.getElementById('shot-portal-root');
  if (existing instanceof HTMLElement) {
    portalRoot = existing;
    return portalRoot;
  }

  const el = document.createElement('div');
  el.id = 'shot-portal-root';
  document.body.appendChild(el);
  portalRoot = el;
  return portalRoot;
}
